module.exports = __webpack_public_path__ + "static/media/client_02.8f3a7740.png";